<template>
    <div >
        <div class="row">
            <div class="col"><button @click="goBack()" class="btn btn-secondary m-3">Back</button></div>
        </div>
        <div class="row align-items-center m-3">
            <div class="col">
                <div>
                    <p class="h1 t-race">{{ this.getReportName}} </p>
                </div>
            </div>
        </div>
        <div class="row align-items-center m-3">
            <div class="col">
                <div>
                    
                    <div class="dropdown show">
                        <a class="btn btn-secondary dropdown-toggle" @click="toggleDropdown()" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          EXPORT
                        </a>
                      
                        <div v-bind:class="dropdownToggle" aria-labelledby="dropdownMenuLink">
                          <a @click="openLink('CSV')" class="dropdown-item" href="#">CSV</a>
                          <a @click="openLink('XL')" class="dropdown-item" href="#">Excel</a>
                          
                        </div>
                      </div>

                </div>
            </div>
        </div>

        
            <div class=" displayBox table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            
                            <th scope="col">POS</th>
                            <th scope="col">Draw</th>
                            <th scope="col">Time</th>
                            <th scope="col">Horse</th>
                            <th scope="col">Weight</th>  
                            <th scope="col">Section</th>
                            <th scope="col">Avg kph</th>
                            <th scope="col">Peak kph</th>
                            <th scope="col">Section Time</th>
                            <th scope="col">Pos Sect</th>
                            <th scope="col">Dist Total</th>
                            <th scope="col">Dist Behind</th>
                            <th scope="col">Avg Speed</th>
                           
                            <th scope="col">No. strides</th>
                            <th scope="col">Mean Stride</th>

                        </tr>
                    </thead>
                    <tbody>

                        <tr v-for="item in getRaceDataForReport" :key="item.raceNumber">
                            
                            <td>{{ item.rank }}</td>
                            <td>{{ item.draw }}</td>
                            <td>{{ item.timeInSeconds }}</td>
                            <td>
                                <div class="horse-details">
                                    <div class="horse-name-area">
                                        {{item.horse}}
                                    </div>
                                    <div class="trainer-jockey-area">
                                        <div class="trainer">{{  item.jockey }}/{{  item.trainer }}</div>                                      
                                    </div>
                                </div>                                
                            </td>
                            <td>
                                <div class="horse-details">
                                    <div class="horse-name-area">
                                        {{item.weight}}
                                    </div>
                                    <div class="trainer-jockey-area">
                                        <div class="trainer">{{item.weightAllowed}}</div>                                      
                                    </div>
                                </div>   
                            </td>
                            <td>{{ item.section }}</td>
                            <td>{{ item.averageTotalInKPH }}</td>
                            <td>{{ item.peakKPH }}</td>
                            <td>{{ item.timeSectionalInSeconds }}</td>
                            <td>{{ item.rankSectional }}</td>
                            <td>{{ item.distanceTotalInMeters }}</td>
                            <td>{{ item.distanceAheadInMeters }}</td>
                            <td>{{ item.averageSpeedInKPH }}</td>                            
                            <td>{{ item.numberOfStrides }}</td>
                            <td>{{ item.meanStrideLength }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { config } from '../../config';

export default {
    name: "ReportView",
    data() {
        return {
            dropdownToggle:'dropdown-menu' , 
            dropdownStatus : false 
        }
    },
    methods: {
        goBack(){
            this.$router.push('/landing/downloads');
        } , 
        dateHeader(){
            return new Date(this.getRaceDataForReport[0].meetingDate).toLocaleDateString('en-za', { weekday:"long", year:"numeric", month:"short", day:"numeric"}) 

        } , 
        openLink(fileType){
            window.open(`${config.reportingURL}/api/Reports/File?raceCourse=${this.getRaceDataForReport[0].raceCourse}&startDate=${this.getRaceDataForReport[0].meetingDate}&raceNumber=${this.getRaceDataForReport[0].raceNumber}&fileType=${fileType}`, '_blank');

        } , 
        toggleDropdown(){
            this.dropdownStatus = !this.dropdownStatus ; 
            this.dropdownToggle = this.dropdownStatus ? "dropdown-menu show" :"dropdown-menu" ; 
        }
    },
    mounted() {
       
    },
    computed: {
        ...mapGetters([
            'getRaceDataForReport' , 
            'getReportName'
        ])
    }
}


</script>



<style scoped>
.horse-details{
    display: flex;
    flex-direction: column;
}
.trainer-jockey-area{
    display: flex;
    flex-direction: row;
    font-style: italic;
    color: grey;
    margin-inline:auto ; 
    
}
.trainer,.jockey{
    padding-inline: 0.3rem;
    font-size: 0.69rem;
}
.trainer{
    padding-right: 0.5rem;
}


.displayBox{
    max-height: 80vh;
    width: 95%;
    overflow: scroll;
    margin-inline: auto;

}
th {
    color: white;
    text-align: center;
    font-weight: bold;
    background-color: #4CAEE3 !important;

}
tr:hover{
    background-color: black;
    color: white;
}
.t-race {
    text-align: center;
}

td {
    text-align: center;
    padding: 0px;
  padding-inline: 0.5rem;
}

.container {
    width: 100% !important;
}
</style>